import React from "react";
import { canonicalizeSentimentReason } from "./greatSentimentReasons";

/**
 * Shows consolidated top-reason label; click toggles the canonical description.
 */
export default function SentimentReasonLabel({
  sentiment,
  rawReason,
  label: labelOverride,
  description: descriptionOverride,
  className = "",
  emptyLabel = "N/A",
}) {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) return;
    const onDocClick = (event) => {
      const target = event?.target;
      if (!target || typeof target.closest !== "function") return;
      if (rootRef.current && !rootRef.current.contains(target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  const raw = String(rawReason ?? "").trim();
  const hasSentiment = sentiment != null && String(sentiment).trim() !== "";
  const canon =
    labelOverride && descriptionOverride
      ? { label: labelOverride, description: descriptionOverride }
      : hasSentiment || raw
        ? canonicalizeSentimentReason(sentiment, raw)
        : null;

  if (!canon) {
    return <span className={className}>{emptyLabel}</span>;
  }

  return (
    <span ref={rootRef} className={`relative inline-block max-w-full ${className}`}>
      <button
        type="button"
        className="max-w-full truncate text-left text-inherit underline decoration-dotted underline-offset-2 hover:text-blue-600 dark:hover:text-blue-400"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        aria-expanded={open}
      >
        {canon.label}
      </button>
      {open ? (
        <span
          role="tooltip"
          className="absolute left-0 top-full z-20 mt-1 w-64 rounded-md border border-gray-200 bg-white p-2 text-[11px] font-normal normal-case leading-snug text-gray-700 shadow-md dark:border-navy-600 dark:bg-navy-800 dark:text-gray-200"
        >
          {canon.description}
        </span>
      ) : null}
    </span>
  );
}
